module.exports = __webpack_public_path__ + "img/mobile-rental-assets-01.356e5641.png";